import { render, staticRenderFns } from "./nfDialog.vue?vue&type=template&id=fedd2ab2&scoped=true"
import script from "./nfDialog.vue?vue&type=script&lang=js"
export * from "./nfDialog.vue?vue&type=script&lang=js"
import style0 from "./nfDialog.vue?vue&type=style&index=0&id=fedd2ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedd2ab2",
  null
  
)

export default component.exports